import React from 'react';
import team from '../../data/team';
import texts from '../../data/texts';

const About = () => {
  return (
    <div className='d-flex flex-column justify-content-center' style={{flex: 1}}>
        <div className='container'>
          <div className='content'>
              <div className='row my-5'>
                  <div className='col-10 col-xl-8 offset-1 offset-xl-2'>

                    <section className="py-5 text-center">
                        <h1>{texts.about.vision.headline}</h1>
                        {texts.about.vision.text.map(line => <p className='lead'>{line}</p>)}
                    </section>

                    <section className="py-5">
                        {team.map((group) =>
                            <div className='row justify-content-md-center'>
                               { group.map((member) =>
                                <div className='text-center col-12 col-sm-6 col-lg-4 mb-4' key={member}>
                                    <img className="mb-3 rounded-circle" src={member.image}  style={{
                                        width: '80%',
                                        height: 'auto',
                                    }}/>
                                    <h5 className="mb-2">{member.name}</h5>
                                    <p>{member.title}</p>
                                </div>
                                )}
                            </div>
                        )}
                    </section>

                  </div>
              </div>
          </div>
        </div>
        <div className="container-fluid bg-lightgray py-5">
            <div className='container'>
                <p className="text-muted">Wir werden unterstützt von</p>
                <div className='row'>
                    <div className='col-12 col-sm-6 col-md-4 col-lg-3 p-4 align-self-center'><img src='/imgs/support_logos/eu_sozialfonds.png' className='supportLogo' /></div>
                    <div className='col-12 col-sm-6 col-md-4 col-lg-3 p-4 align-self-center'><img src='/imgs/support_logos/logo_hwr.png' className='supportLogo' /></div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default About;



// WEBPACK FOOTER //
// ./src/components/pages/About.js